import * as React from 'react';
import { statusRed } from '../../cssConstants';
import PrimaryButton from '../buttons/PrimaryButton';
import SecondaryButton from '../buttons/SecondaryButton';
import MessageDialog from './MessageDialog';

const YesNoDialog = (props: Props) => {
	const [buttonsDisabled, setButtonsDisabled] = React.useState<boolean>(false);

	const onClickWrapper = (onClick: () => void) => () => {
		setButtonsDisabled(true);
		onClick();
		setButtonsDisabled(false);
	};

	const buttons = (
		<>
			<SecondaryButton text={props.noButtonText} onClick={onClickWrapper(props.onNo)} disabled={buttonsDisabled} />
			<PrimaryButton
				text={props.yesButtonText}
				onClick={onClickWrapper(props.onYes)}
				disabled={buttonsDisabled}
				backgroundColor={props.yesButtonIsDelete ? statusRed : undefined}
			/>
		</>
	);

	return (
		<MessageDialog
			heading={props.heading}
			message={props.message}
			buttons={buttons}
			onClose={props.onNo}
			width={props.width}
		/>
	);
};

interface Props {
	heading?: string;
	message: string;
	onYes: () => void;
	onNo: () => void;
	yesButtonText?: string;
	noButtonText?: string;
	yesButtonIsDelete?: boolean;
	width?: number;
}

YesNoDialog.defaultProps = {
	heading: null,
	yesButtonText: 'Yes',
	noButtonText: 'No',
	yesButtonIsDelete: false,
	width: undefined
};

export default YesNoDialog;
